import { render, staticRenderFns } from "./SliderPreview.vue?vue&type=template&id=825176da&scoped=true"
import script from "./SliderPreview.vue?vue&type=script&lang=js"
export * from "./SliderPreview.vue?vue&type=script&lang=js"
import style0 from "./SliderPreview.vue?vue&type=style&index=0&id=825176da&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825176da",
  null
  
)

export default component.exports